import * as React from "react";
import { api, user } from "src/services/api";
import { redirect, route, routeApi } from "src/services/browser";
import { FormState, Form, Fieldset, bindToAPI, resetState } from "src/services/form";
import { notify } from "src/services/notify";

import Modal from "../ui/Modal";

interface Props {
    id: any;
    onClose: Function;
}
interface State {
    scuola?: any;
}
export class ScuolaRichiestaContatto extends React.Component<Props, State> {
    state = {
    } as State;

    async componentDidMount() {
        const { id } = this.props;
        const item = await api({
            url: routeApi('scuola.show', { scuola: id }),
            method: 'get'
        });
        this.setState({
            scuola: item
        });
    }

    async submit( values ) {
        const { id } = this.props;
        try {
            const data = await bindToAPI( this, {
                    method: "POST",
                    url: routeApi('messaggio.store'),
                    data: {
                        recipient_id: id,
                        recipient_type: `App\\\Scuola`,
                        ...values   
                    },
                    loading: this
            });
            notify( { text: 'Messaggio inviato correttamente.', type: 'success' } );
            this.cancel();
        } catch(errors) {
        
        }
        console.log(values)
    }
    
    cancel() {
        const { onClose } = this.props;
        if (onClose) {
            onClose();
        }
    }
  
    render() {
        const { children, id } = this.props;
        const { scuola = null } = this.state;
        if (!scuola) return null;
        
        return (
            <Modal
              open={true}
              backdrop={true}
              icon={"info"}
              className="scuola_RichiestaContatto "
              onClose={() => this.cancel()}
            >
              <header>
                <h2>Richiesta informazioni</h2>
                <h3>{scuola.nome}</h3>
                <p>{scuola.indirizzo_completo}</p>
              </header>
              <Form onSubmit={values => this.submit(values)} render={(form) => {
              return (
              <>
              <section>
                <h2>I tuoi dati</h2>
                <p>
                    Mittente: {user.nome} {user.cognome}<br />
                    Email: {user.email}
                </p>
                <form>
                <Fieldset
                fieldsParams={{
                    'testo': { type: 'textarea', placeholder: 'Scrivi qui il testo della tua richiesta' },
                } as any}
                />
                </form>
                <div className="help">
                    Una messaggio email verrà inviato alla scuola, la quale ti ricontatterà al più presto.<br />
                    Riceverai una notifica di conferma nella tua casella di posta elettronica.<br />
                    I contenuti dei messaggi NON hanno valore contrattuale.
                </div>
              </section>
              <footer>
                  <a className="huge" onClick={form.submitForm}>
                    <span>Invia richiesta</span>
                    <span className="icon-checked" />
                  </a>
              </footer>
              </>
                )
              }} />
            </Modal>
        );
    }
}

interface StateToggler {
    open: "modal" | null;
}
export default class ScuolaRichiestaContattoToggler extends React.Component<any, StateToggler> {
    constructor(props) {
        super(props);
        this.state = {
            open: null
        };
    }
    
    execute() {
        this.setState({open: "modal"});
    }
    
    render() {
        const { open = null } = this.state;
        const props = {
            ...this.props,
            onClose: () => this.setState({open: null})
        } as any;
        return (
        <>
            {open === "modal" &&
            <ScuolaRichiestaContatto {...props} />
            }
            <span onClick={() => this.execute() }>
                {this.props.children}
            </span>
        </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/scuola/RichiestaContatto.tsx